import { useState } from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import { enqueueSnackbar, } from 'notistack';
import { IconButton, Tooltip, Stack } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { backendDateFormat, fieldDateFormat } from "../../../constants";
import { globalPutService } from "../../../utils/globalApiServices";
import { updateAsOfDateApi } from "../apiServices";
import { checkApiStatus } from "../../../utils";
import { PageLoader } from "../../../shared_elements";

const AsOfDateCard = ({ shopVisit, asOfDate, onFieldChange, getResponseBack, onToggleMode }) => {
    const [isLoading, setLoading] = useState(false)
    const { leaseBasicDetails } = useSelector((state) => state.leases);
    const validateDate = (value,) => {
        if (!value) return false;
        const date = moment(value);

        if (!date.isValid()) {
            enqueueSnackbar("As Of Date must be a valid Date", { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" } })
            return false;
        }
        if (!(date.year() >= 1900 && date.year() <= 2100)) {
            enqueueSnackbar("Year must be between 1900 and 2100.", { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" } })
            return false;
        }
        if (date &&moment(leaseBasicDetails.start_date).isAfter(moment(date))) {
             enqueueSnackbar(`As of Date : Must be between lease start and end dates.`, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
             return false
        }
        else if (date && moment(leaseBasicDetails.end_date).isBefore(date)) {
            enqueueSnackbar(`As of Date : Must be between lease start and end dates.`, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
            return false
        }
       
        return true
    };
    const editAsOfDate = () => {
        if (validateDate(asOfDate)) {
            setLoading(true)
            globalPutService(updateAsOfDateApi(shopVisit?.slug), { as_of_date: asOfDate.format(backendDateFormat) })
                .then((response) => {
                    if (checkApiStatus(response)) {
                        getResponseBack()
                        onToggleMode()
                    }
                    setLoading(false);
                });
        }
    }
    return (
        <>
            {/* <Card sx={{ p: 1, borderRadius: 3, boxShadow: "0 2px 8px rgba(0,0,0,0.08)" }} >
                <Typography sx={{ fontSize: 13, color: "text.secondary", fontWeight: 500 }} > As of Date </Typography> */}
            <Stack direction="row" alignItems="center" spacing={1.5}>
                {/* {editMode ? ( */}
                <>
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                        <DatePicker
                            value={asOfDate ? moment(asOfDate) : null}
                            format={fieldDateFormat}
                            slotProps={{
                                textField: {
                                    size: "small",
                                    variant: "outlined",
                                    sx: {
                                        width: 125,
                                        "& .MuiInputBase-input": {
                                            padding: "4px 4px",
                                            fontSize: 13
                                        }
                                    }
                                }
                            }}
                            // slotProps={{ textField: { size: "small", sx: { width: 148, "& .MuiOutlinedInput-root": { height: 30 } },  } }}
                            onChange={onFieldChange}
                        />
                    </LocalizationProvider>
                    <Stack direction="row" alignItems="center" spacing={0.5}>
                        <Tooltip title="Save">
                            <IconButton color="primary" size="small" onClick={() => { editAsOfDate(asOfDate); }} sx={{ bgcolor: "#e3f2fd", }} > <CheckIcon fontSize="small" sx={{ fontSize: 16 }} /> </IconButton>
                        </Tooltip>
                        <Tooltip title="Cancel">
                            <IconButton color="error" size="small" onClick={onToggleMode} sx={{ bgcolor: "#ffebee" }} > <CloseIcon fontSize="small" sx={{ fontSize: 16 }} /> </IconButton>
                        </Tooltip>
                    </Stack>
                </>

            </Stack>
            {/* </Card> */}
            {isLoading ? <PageLoader /> : null}
        </>
    )
}

export default AsOfDateCard